import { render } from "./MainIndex.vue?vue&type=template&id=5d785f9c"
import script from "./MainIndex.vue?vue&type=script&lang=js"
export * from "./MainIndex.vue?vue&type=script&lang=js"

import "./MainIndex.vue?vue&type=style&index=0&id=5d785f9c&lang=css"

import exportComponent from "/codebuild/output/src1559117955/src/employer_portal_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__